import styled from 'styled-components';

export default styled.h3`
    font-family: 'Brown Bold', Arial, Helvetica, sans-serif;
    font-size: 80%;
    text-transform: uppercase;
`;
